import { Button, Checkbox, Dropdown, Icon, Menu, Modal, Pagination, Progress } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { profileSelector } from '../../modules/profile';
import Spiner from '../helpers/Spiner/Spiner';
import { getParams } from '../PresentationsStart/actions';
import { deleteQuestions, getQuestions, importQuestions } from './actions';
import Question from './components/Question';
import './style.scss';
import PropTypes from 'prop-types'
import ModalImport from './components/ModalImport';
import { toastr } from 'react-redux-toastr';
import { cloneDeep } from 'lodash';
import { checkAndUploadQuestions } from '../../modules/questions';
import CheckboxCustom from './components/Checkbox';

const { confirm } = Modal;

export class QuestionImport extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.ref = React.createRef();
    this.state = {
      loaded: false,
      showAnswer: false,
      showDescription: false,
      questions_data: [],
      questions: [],
      params: {},
      selected: [],
      isOpenImport: false,
      pageSize: 10,
			currentPage: 1,
      procentUpload: 0,
      uploaded: true,
			// questions: this.paginate(props.questions, 10, 1),
    }
  }

  onQuestion = async () => {
    const questions = await getQuestions();
    this.setState({
      loaded: true,
      questions_data: questions,
      questions: this.paginate(questions, this.state.pageSize, 1),
    })
  }

  async componentDidMount(){
    const questions = await getQuestions();
    const params = await getParams();
    this.setState({
      loaded: true,
      questions_data: questions,
      questions: this.paginate(questions, this.state.pageSize, 1),
      params
    })
  }

  upload = (formData) => new Promise((resolve, reject) => {

    var xhr = new XMLHttpRequest();
    const {params} = this.state;
    // обработчик для отправки
    xhr.upload.onprogress = (event) => {
      try {
        const pr = 100/event.total;
        const res = Math.round(event.loaded * pr)
        this.setState({
          procentUpload: res > 100 ? 100 : res,
          uploaded: res == 100
        })
      } catch (error) {
        console.log("🚀 ~ file: QuestionImport.jsx ~ line 70 ~ QuestionImport ~ upload= ~ error", error)
      }
    }

    // обработчики успеха и ошибки
    // если status == 200, то это успех, иначе ошибка
    xhr.onload = xhr.onerror = function() {
      if (this.status == 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };

    xhr.open("POST", params.microservicesApi + '/qti/import', true);
    xhr.send(formData)
  })

  onChangeFile = async (e) => {
    const {formatMessage} = this.context;
    try {
      const file = e.target.files[0];
      if(file.name.indexOf('.zip') < 0){
        toastr.error(formatMessage('errZipUploadType'), formatMessage('msgErrZipUploadType'))
        return;
      }

      
      const {profile} = this.props;
      const formData = new FormData();
      this.setState({loaded: false, uploaded: false, procentUpload: 0});
      formData.append( 
        "file", 
        e.target.files[0],
      );
      formData.append( 
        "user_id", 
        profile.id,
      );
      await this.upload(formData)

      // const data = await fetch(params.microservicesApi + '/qti/import', {
      //   method: 'POST',
      //   body: formData
      // }).then(res => res.json())
      await this.onQuestion()
      if(this.ref.current){
        this.ref.current.value = '';
      }
    } catch (error) {
      if(this.ref.current){
        this.ref.current.value = '';
      }
      this.setState({loaded: true})
      toastr.error(formatMessage('errZipUploadFile'), formatMessage('msgErrZipUploadFile'))
      console.log("🚀 ~ file: QuestionImport.jsx ~ line 48 ~ QuestionImport ~ onChangeFile= ~ error", error)
    }
  }

  deleteSelectedItem = async() => {
    const {selected} = this.state;
    this.setState({loaded: false, selected: []});
    await deleteQuestions(selected)
    await this.onQuestion()
  }

  importSelectedItem = async (values) => {
    this.setState({loaded: false, isOpenImport: false, selected: []});
    await importQuestions({...values, ids: this.state.selected})
    await this.onQuestion()
    this.props.checkAndUploadQuestions();
  }

  onShowSizeChange = (current, pageSize) => {
		this.setState({
			questions: this.paginate(this.state.questions_data, pageSize, current),
			pageSize,
			currentPage: current
		})
	}

  paginate = (array, page_size, page_number) => {
		if(page_number == 0){
			return cloneDeep(array).slice(0, page_size);
		}
  	--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
	}

  scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
        if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval); 
    },15);
	}

  render() {
    const {formatMessage} = this.context;
    const {loaded, questions, selected, isOpenImport, questions_data, pageSize, currentPage, uploaded, procentUpload, showAnswer, showDescription } = this.state;
    const {profile} = this.props;
    return (
      <div className="qbm-content QuestionImport">
          {!loaded && <div className='spinner-block'>
            {!uploaded && <Progress type="circle" percent={procentUpload} />}
            {!uploaded && <p style={{marginTop: 20}}>{formatMessage('uploadFileImport')}</p>}
            {uploaded && <Spiner/>}
            {uploaded && <p className='text-spinner'>{formatMessage('parceImportFile')}</p>}
          </div>}
          <ModalImport isOpen={isOpenImport} onClose={() => {this.setState({isOpenImport: false})}} importSelectedItem={this.importSelectedItem} />
            <div className="Questions question-container">
              <div className='actions_btn'>
                <label className='ant-btn ant-btn-primary'>
                  Upload QTI.zip
                  <input type="file" ref={this.ref} onChange={this.onChangeFile} style={{display: 'none'}} />
                </label>
                <div className='block2'>
                  <Button type="primary" disabled={selected.length == 0} onClick={() => {
                    this.setState({isOpenImport: true})
                  }}>{formatMessage('importSelectedItems')}</Button>
                  <Button type='danger' disabled={selected.length == 0} onClick={() => {
                    confirm({
                      title: formatMessage('modalTitleDeleteQuestion'),
                      content: formatMessage('modalMessageDeleteQuestion'),
                      onOk: () => {
                        this.deleteSelectedItem();
                      },
                      onCancel() {
                        console.log('Cancel');
                      },
                    });
                    
                  }}>{formatMessage('deleteSelectedItems')}</Button>
                  <div className='block-check'>
                    <Checkbox 
                      checked={questions_data.length > 0 && selected.length == questions_data.length} 
                      indeterminate={selected.length > 0 ? selected.length != questions_data.length : false}
                      onChange={() => {
                        if(selected.length == questions_data.length){
                          this.setState({selected: []})
                        } else {
                          this.setState({selected: questions_data.map(_i => _i.id)})
                        }
                      }} />
                  </div>
                </div>
              </div>
              <div className='actions_btn2'>
                <CheckboxCustom value={showAnswer} style={{marginRight: 10}} onChange={(value) => {
                  this.setState({showAnswer: value})
                }} label={formatMessage('hideAnswersAll')} />
                <CheckboxCustom value={showDescription} onChange={(value) => {
                  this.setState({showDescription: value})
                }} label={formatMessage('hideExplanationAll')} />
              </div>
              <div>
                {questions.length > 0 && <Pagination
                  style={{marginTop: 20, marginBottom: 20}}
                  showSizeChanger
                  onShowSizeChange={this.onShowSizeChange}
                  total={questions_data.length}
                  pageSizeOptions={['5', '10', '20', '50']}
                  pageSize={pageSize}
                  current={currentPage}
                  onChange={(page, pageSize) => {
                      
                    this.setState({
                      questions: this.paginate(this.state.questions_data, pageSize, page),
                      pageSize,
                      // selected: [],
                      currentPage: page,
                    }, () => {
                      this.scrollToTop(500);
                    })
                  }}
                />}
                {questions.map(question => (
                  <Question
                    key={'question-' + question.id} 
                    question={question}
                    showAnswerParent={showAnswer}
                    showDescriptionParent={showDescription}
                    isSelected={selected.includes(question.id)}
                    onSelect={(id) => this.setState({selected: selected.includes(id) ? selected.filter(_i => _i != id) : [...selected, id]})}
                  />))}
                  {questions.length > 0 && <Pagination
                    style={{marginTop: 20, marginBottom: 20}}
                    showSizeChanger
                    onShowSizeChange={this.onShowSizeChange}
                    total={questions_data.length}
                    pageSizeOptions={['5', '10', '20', '50']}
                    pageSize={pageSize}
                    current={currentPage}
                    onChange={(page, pageSize) => {
                        
                      this.setState({
                        questions: this.paginate(this.state.questions_data, pageSize, page),
                        pageSize,
                        currentPage: page,
                      }, () => {
                        this.scrollToTop(500);
                      })
                    }}
                  />}
              </div>
            </div>
        </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: profileSelector(state)
})

const mapDispatchToProps = {
  checkAndUploadQuestions,
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionImport) ;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionImport/QuestionImport.jsx